import React from 'react';
import * as Yup from 'yup';
import TextInput from '@atoms/TextInput/index';

export const editProfileContactValidationSchema = {
    email: Yup.string()
        .email('Must be a valid email.')
        .required('Email is required.'),
    secondaryEmail: Yup.string().email('Must be a valid email.'),
    workPhone: Yup.string().required('Phone is required.'),
};

const EditProfileFieldsContact = () => (
    <>
        <TextInput label="Email" name="email" type="email" required />
        <TextInput label="Secondary Email" name="secondaryEmail" type="email" />
        <TextInput label="Phone" name="workPhone" type="text" required />
        <TextInput label="Mobile Phone" name="cellPhone" type="text" />
        <TextInput label="Fax" name="fax" type="text" />
    </>
);

export default EditProfileFieldsContact;
